import script from "./ItemInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemInfo.vue?vue&type=script&setup=true&lang=js"

import "./ItemInfo.vue?vue&type=style&index=0&id=dc7f89ce&lang=css"

const __exports__ = script;

export default __exports__